import React, { useEffect, useState } from "react";
import axios from "axios";

import { Row, Col, Card, Typography } from "antd";
import "./css/dashboard.css";

import Barchart from "./chartJs/Barchart";

const { Title } = Typography;

const cardStyle = {
  height: 420,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};

const Dashboard7_3 = () => {
  let xURL = "";

  xURL = "https://research.rihes.cmu.ac.th/api/";

  const [dataBar7_3_1, _dataBar7_3_1] = useState();
  const [dataBar7_3_2, _dataBar7_3_2] = useState();
  const [dataBar7_3_3, _dataBar7_3_3] = useState();
  const [dataBar7_3_4, _dataBar7_3_4] = useState();

  useEffect(() => {
    Find_barData("bar7_3_1");
    Find_barData("bar7_3_2");
    Find_barData("bar7_3_3");
    Find_barData("bar7_3_4");
  }, []);

  const Find_barData = order => {
    axios
      .post(xURL + "db_barchart_db7_3", {
        order: order
      })
      .then(result => {
        let Tb1 = [];

        if (result.data) {
          result.data.forEach((i, idx) => {
            let zyear = "";

            zyear = i.name + 543;

            if (order == "bar7_3_1") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_3_2") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_3_3") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_3_4") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            }
          });
        }

        if (order == "bar7_3_1") {
          _dataBar7_3_1(Tb1);
        } else if (order == "bar7_3_2") {
          _dataBar7_3_2(Tb1);
        } else if (order == "bar7_3_3") {
          _dataBar7_3_3(Tb1);
        } else if (order == "bar7_3_4") {
          _dataBar7_3_4(Tb1);
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  return (
    <React.Fragment>
      {/* Page Title */}
      <div style={{ marginBottom: 24 }}>
        <Title level={2} className="gradient-text">
          ผลลัพธ์ด้านบุคลากร
        </Title>
      </div>

      {/* Row 1 */}
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="จำนวนผลงานวิจัยที่เผยแพร่ใน SCOPUS ต่อนักวิจัย"
          >
            <Barchart dataBar={dataBar7_3_1} order={"bar7_3_1"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="จำนวนผลงานวิจัยที่เผยแพร่ใน SCOPUS Q1 ต่อนักวิจัย"
          >
            <Barchart dataBar={dataBar7_3_2} order={"bar7_3_2"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 2 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="จำนวนการอ้างอิงผลงานวิจัยต่อนักวิจัย"
          >
            <Barchart dataBar={dataBar7_3_3} order={"bar7_3_3"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(255, 63, 29)"
            }}
            title="ร้อยละนักวิจัยที่มีตำแหน่งวิชาการ"
          >
            <Barchart dataBar={dataBar7_3_4} order={"bar7_3_4"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Dashboard7_3;
